<template>
  <div>
    <div
      v-if="loaded"
      class="flex flex-col md:flex-row items-center content-center px-2 mt-4"
    >
      <h2
        v-if="categories.length"
        class="flex-1 m-0 mb-2"
      >
        Categories
        <span
          v-if="loaded"
          v-text="`(${count})`"
        />
      </h2>
      <div class="my-2">
        <a
          v-if="categories.length"
          v-can="'archive-discussions'"
          :href="archivedUrl"
          class="btn btn--border btn--sm mr-4"
          v-text="'Archived'"
        />
        <button
          v-if="categories.length"
          v-can="'create-discussion-categories'"
          type="button"
          class="btn btn--border btn--sm"
          @click="$store.commit('discussionCategoryModalOpen')"
          v-text="'Create New Category'"
        />
      </div>
    </div>
    <ContentSectionLoader v-if="!loaded && showLoader" />
    <div
      v-if="loaded"
      class="flex flex-row flex-wrap"
    >
      <DiscussionCategory
        v-for="category in categories"
        :key="category.uuid"
        :category="category"
      />
    </div>
    <div
      v-if="loaded && !categories.length"
      class="empty mb-4 mx-2"
    >
      <section>
        <h2 v-text="'Before we can start talking...'" />
        <p>In order to start discussions an Organization Admin needs to create some categories.</p>
        <button
          v-can="'create-discussion-categories'"
          type="button"
          class="btn btn--border"
          @click="$store.commit('discussionCategoryModalOpen')"
          v-text="'Create a category'"
        />
      </section>
    </div>
  </div>
</template>

<script type="text/babel">
import { mapActions, mapState } from 'vuex'

export default {
  name: 'DiscussionCategoryList',
  props: {
    archived: {
      type: Boolean,
      required: false,
      default: false,
    },
    showLoader: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {
      loaded: false,
    }
  },
  computed: {
    ...mapState({
      count: state => state.discussion.categories.data.length,
      totalCount: state => _.get(state.discussion.categories, 'meta.pagination.total', 0),
      categories: state => state.discussion.categories.data,
    }),
    params() {
      const params = {}

      if (this.archived) {
        params.archived = true
      }

      return params
    },
    archivedUrl() {
      return this.$urlGenerator.active('discussions/archived#categories')
    },
  },
  mounted() {
    this.discussionGetCategories(this.params).then(() => {
      this.$emit('loaded')

      this.loaded = true
    })
  },
  methods: {
    ...mapActions([
      'discussionGetCategories',
    ]),
  },
}
</script>
